export function useKpiHelpers() {
  const formattedResult = (val, format = '%') => {
    if (!val || val.Result == null) return '-';

    if(format === '%') {
      return `${val.Result}%`;
    } else {
      return val.Result;
    }
  };

  const lastResult = (kpi, format = '%') => {
    // const val = last(kpi.SurveyWave);
    return formattedResult(last(kpi.SurveyWave), format);
  };

  const lastResultTarget = (kpi, format = '') => {
    return 100;
  };

  const secondLastResult = (kpi, format = '%') => {
    // const val = fromEnd(kpi.SurveyWave, 2);
    return formattedResult(secondLast(kpi.SurveyWave), format);
  };

  const lastWave = (kpi) => {
    if (!kpi || !Array.isArray(kpi.SurveyWave) || kpi.SurveyWave.length === 0) {
      return undefined;
    }
    return kpi.SurveyWave.at(-1);
  };

  const last = (arr) => {
    if (!Array.isArray(arr) || arr.length === 0) return undefined;
    return arr.at(-1);
  };

  const fromEnd = (arr, n = 1) => {
    if (!Array.isArray(arr) || arr.length === 0) return undefined;
    return arr.at(-n);
  };

  const secondLast = (arr) => fromEnd(arr, 2);

  const country = (kpi) => {
    return kpi?.country || 'DE';
  };

  const wave = (kpi, format = 'sm')  => {
    const lw = lastWave(kpi);
    const name = lw ? lw.Name : '-';
    switch(format) {
      case 'sm':
        return name.replace('Welle','W').replace('W 0','W0').replace('2025','25').replace('2026','26').trim()
          .replace('-','/').replace('_','/').replace(' / ',' ').trim();
      case 'lg':
        return name.replace('-','/').replace('_','/').trim(); ;
    }
    return lw ? lw.Name : 'WAVE';
  };

  const state = (kpi) => {
    const lw = lastWave(kpi);
    return lw && lw.Status ? lw.Status : 'DATAFREEZE';
  };

  return {
    country,
    wave,
    state,
    lastResult,
    lastResultTarget,
    secondLastResult,
    lastWave,
    last,
    fromEnd,
    secondLast,
  };
}
